import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS. Always sanitize any HTML before using
 * it with dangerouslySetInnerHTML or assigning to element.innerHTML.
 */
export function sanitizeHtml(html?: string): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true } });
}


